import React from 'react';
import GridCell from './GridCell';

function GridRow({
                     row,
                     rowIndex,
                     totalRows,
                     selectedRow,
                     selectedCell,
                     selectedElement,
                     containerWidth,
                     onSelectRow,
                     onSelectCell,
                     onSelectElement,
                     onSelectNestedCell,
                     onMoveRow,
                     onDeleteRow,
                     onAddNestedGrid,
                     onClearCell,
                     onClearNestedCell,
                     onDeleteElement,
                     onDrop,
                     onDragOver,
                     onCellResize,
                     onElementDragStart,
                     onElementDrop,
                     onAddColumn,
                     onDeleteColumn,
                     onMoveColumn,
                     onDeleteNestedColumn,
                     onMoveNestedColumn,
                     onAddNestedColumn,
                     onMoveElement,
                     previewMode,
                     previewMember,
                     demoAssets,
                     onDetachTemplate
                 }) {
    return (
        <div
            className={`grid-row ${selectedRow === rowIndex ? 'selected' : ''} ${previewMode ? 'preview-mode' : ''}`}
            style={{ width: `${containerWidth + 5}px` }}
            onClick={(e) => { e.stopPropagation(); !previewMode && onSelectRow(rowIndex); }}
        >
            {!previewMode && (
                <div className="row-controls">
                    {rowIndex > 0 && (
                        <button
                            className="row-control-btn"
                            onClick={(e) => { e.stopPropagation(); onMoveRow(rowIndex, 'up'); }}
                            title="Déplacer vers le haut"
                        >
                            ↑
                        </button>
                    )}
                    {rowIndex < totalRows - 1 && (
                        <button
                            className="row-control-btn"
                            onClick={(e) => { e.stopPropagation(); onMoveRow(rowIndex, 'down'); }}
                            title="Déplacer vers le bas"
                        >
                            ↓
                        </button>
                    )}
                    <button
                        className="row-control-btn danger"
                        onClick={(e) => { e.stopPropagation(); onDeleteRow(rowIndex); }}
                        title="Supprimer la ligne"
                    >
                        ×
                    </button>

                    {/* NOUVEAU: Bouton pour ajouter une colonne */}
                    {row.cells.length < 4 && (
                        <button
                            className="row-control-btn success"
                            onClick={(e) => { e.stopPropagation(); onAddColumn(rowIndex); }}
                            title="Ajouter une colonne"
                        >
                            ➕
                        </button>
                    )}
                </div>
            )}

            <table className="row-table" style={{ width: `${containerWidth}px` }}>
                <tbody>
                <tr>
                    {row.cells.map((cell, cellIndex) => (
                        <GridCell
                            key={cellIndex}
                            cell={cell}
                            rowIndex={rowIndex}
                            cellIndex={cellIndex}
                            totalColumns={row.cells.length}
                            isSelected={selectedCell?.rowIndex === rowIndex && selectedCell?.cellIndex === cellIndex && !selectedCell?.isNested}
                            selectedElement={selectedElement}
                            selectedCell={selectedCell}
                            onSelect={(e) => {
                                e.stopPropagation();
                                onSelectElement(null); // Désélectionner l'élément d'abord
                                onSelectCell({ rowIndex, cellIndex });
                            }}
                            onAddNestedGrid={() => onAddNestedGrid(rowIndex, cellIndex)}
                            onClear={() => onClearCell(rowIndex, cellIndex)}
                            onSelectElement={onSelectElement}
                            onSelectNestedCell={onSelectNestedCell}
                            onDeleteElement={onDeleteElement}
                            onClearNestedCell={onClearNestedCell}
                            onDrop={onDrop}
                            onDragOver={onDragOver}
                            onCellResize={onCellResize}
                            onElementDragStart={onElementDragStart}
                            onElementDrop={onElementDrop}
                            onDeleteColumn={() => onDeleteColumn(rowIndex, cellIndex)}
                            onMoveColumn={(direction) => onMoveColumn(rowIndex, cellIndex, direction)}
                            onDeleteNestedColumn={onDeleteNestedColumn}
                            onMoveNestedColumn={onMoveNestedColumn}
                            onAddNestedColumn={onAddNestedColumn}
                            onMoveElement={onMoveElement}
                            onSelectCell={onSelectCell}
                            onSelectRow={onSelectRow}
                            previewMode={previewMode}
                            previewMember={previewMember}
                            demoAssets={demoAssets}
                            onDetachTemplate={() => onDetachTemplate(rowIndex, cellIndex)}
                        />
                    ))}
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default GridRow;
